import { parse } from "date-fns";

export default function parseDateTime(s: string, baseDate = new Date()): Date {
  return parse(s, "yyyy-MM-dd'T'HH:mm", baseDate);
}
